import { Container, VStack, Alert, Button } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'

/**
 * Route-level guard for Organizer/Admin/SuperAdmin-only pages (`useAuth().isOrganizer` already
 * folds all three roles in — see the frontend CLAUDE.md security note). Mirrors AdminGuard's
 * shape exactly, just gated on `isOrganizer` instead of `isAdmin`.
 *
 * UX-only, same as AdminGuard: every endpoint underneath (Communications create/preview/send)
 * independently enforces Organizer/Admin server-side.
 */
export function OrganizerGuard({ children }: { children: React.ReactNode }) {
  const { isOrganizer, isAuthenticated } = useAuth()
  const navigate = useNavigate()

  if (!isAuthenticated) {
    navigate('/login')
    return null
  }

  if (!isOrganizer) {
    return (
      <Container maxW="container.md" py={16}>
        <VStack gap={4}>
          <Alert.Root status="error" borderRadius="md">
            <Alert.Indicator />
            Access denied. Organizer privileges are required to view this page.
          </Alert.Root>
          <Button colorPalette="brand" onClick={() => navigate('/dashboard')}>
            Return to Dashboard
          </Button>
        </VStack>
      </Container>
    );
  }

  return <>{children}</>
}
